import type { RouteObject } from 'react-router';

import { registerEditorialBlocks } from '../_shared/blocks';
import { EditorialNewPage } from './EditorialNew';

/** Author a new post. Always a draft, and the service assigns that state. */
registerEditorialBlocks();

export const editorialNewRoute: RouteObject = {
  // Declared before `editorial/:postId` in the aggregator, so «new» is a route
  // rather than a post whose id happens to be that word.
  path: 'editorial/new',
  element: <EditorialNewPage />,
};
